/**
 * Canonical app language codes persisted via setAppLanguage / localStorage.
 */
export function resolveAppLanguage(i18nLanguage) {
  if (!i18nLanguage) return 'en';
  const base = (String(i18nLanguage).split('-')[0] || '').toLowerCase();
  if (base === 'zh') return 'zh';
  if (base === 'ar') return 'ar';
  return 'en';
}

export function isRtlLocale(i18nLanguage) {
  return resolveAppLanguage(i18nLanguage) === 'ar';
}
